import { render } from "./annualLoss.vue?vue&type=template&id=759c64ec&scoped=true"
import script from "./annualLoss.vue?vue&type=script&lang=js"
export * from "./annualLoss.vue?vue&type=script&lang=js"

import "./annualLoss.vue?vue&type=style&index=0&id=759c64ec&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759c64ec"]])

export default __exports__